import {
  ApplicationRef,
  createComponent,
  EmbeddedViewRef,
  EnvironmentInjector,
  Injectable,
  Type,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppendComponentToBodyService {
  constructor(
    private readonly appRef: ApplicationRef,
    private readonly environmentInjector: EnvironmentInjector
  ) {}

  append<T>(component: Type<T>): void {
    const componentRef = createComponent(component, {
      environmentInjector: this.environmentInjector,
    });

    this.appRef.attachView(componentRef.hostView);

    const domEl = (componentRef.hostView as EmbeddedViewRef<T>).rootNodes[0];
    const bodyElement = document.getElementsByTagName('body')[0];

    bodyElement.appendChild(domEl);
  }
}
